import React from 'react';
import { useTranslations, useLocale } from 'next-intl';

import Form from '../../molecules/form/form';
import contactGerman from './data/01-contact';
import contactEnglish from './data/02-contact-en';

const contactData = {
  de: contactGerman,
  en: contactEnglish
};

const ContactForm = () => {
  const locale = useLocale();
  const t = useTranslations();
  return <Form {...contactData[locale]} withCsrfToken successMessage={t('form.success')} />;
};

export default ContactForm;
